<template>
<v-app>
  <v-main
  >

      <m-make-payment-content
        :payment="payment"
        :banner_branding="banner_branding"
        :payment_not_found="payment_not_found"
        :stage="stage"
        v-on:change-stage="onChangeStage"
        v-on:update="loadPayment"
        :preview="preivew"
      />

    </v-main>


  <m-global-spinner/>
  <m-global-snackbar/>
  <m-global-alert/>
  <m-global-confirm/>
  <m-global-prompt/>

</v-app>
</template>

<script>

export default {

    data() {
        return {
            payment: null,
            banner_branding: null,
            payment_not_found: false,

            stage: 1,
        }
    },

    props: {
      preview: {
        type: Boolean,
        default: function() { return false; }
      },
    },

    mounted () {
        this.loadPayment();
    },   

    methods: {
      loadPayment()
      {
        this.$rc.showSpinner();
        this.payment_not_found = false;

        this.$rc.getPayment(
            this.$route.params.payment_id,
            "get-public",

            (data) => {
                this.$rc.hideSpinner();
                this.payment = data.payment;
                this.banner_branding = data.banner_branding;

                if ( this.payment.request.amount_of_address_information == 'billing-and-shipping-address' )
                {
                  this.stage = 1;
                }
                else if ( this.payment.request.amount_of_address_information == 'billing-address' )
                {
                  this.stage = 2;
                }
                else
                {
                  this.stage = 3;
                }
            },

            () => {
                this.$rc.hideSpinner();
                this.payment_not_found = true;
            }
        );
      },

      onChangeStage(new_stage)
      {
        this.stage = new_stage;
      }
    },
}
</script>

<style lang="scss" scoped>
</style>